/*
 *  -----------------------------------------------------------------------
 *    <copyright file="no-study-selected.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';

import { useTranslation } from 'hooks';

const NoStudySelected = React.memo(() => {
    const { t } = useTranslation();

    return <h1>{t('noStudySelected')}</h1>;
});

export default NoStudySelected;
